import React, { Component } from 'react';
import moment from 'moment';
import axios from 'axios';
import PropTypes from 'prop-types';
import { withLocalize, Translate } from 'react-localize-redux';

import RecentReview from '../components/RecentReview';


class RecentReviewPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reviews: [],
    };

    this.fetchReviews = this.fetchReviews.bind(this);
  }

  componentDidMount() {
    const { activeLanguage, chsiteId } = this.props;
    this.fetchReviews(activeLanguage, chsiteId);
  }

  componentDidUpdate(prevProps) {
    const { activeLanguage, chsiteId } = this.props;

    if (
      activeLanguage !== prevProps.activeLanguage || chsiteId !== prevProps.chsiteId
    ) { this.fetchReviews(activeLanguage, chsiteId); }
  }


  fetchReviews(activeLanguage, chsiteId) {
    // This variable supplies date 3 days ago from today to give moderators
    // time to delete inappropriate reviews (production)

    const daysAgo = moment().subtract(3, 'days').format('YYYY-MM-DD');

    const link = `/analytics/sites/${chsiteId}/reviews?o=-review_date&limit=3&review_date__lte=${daysAgo}`
      + `&language=${activeLanguage.name}`;

    axios({
      method: 'get',
      url: link,
      crossdomain: true,
    })
      .then((res) => {
        const reviews = res.data;
        this.setState({ reviews });
      });
  }


  render() {
    const { reviews } = this.state;

    const recentReviews = reviews.map((review) => (
      <RecentReview
        key={review.title}
        review={review.review_text}
        rating={parseInt(review.star_rating, 10)}
        date={review.review_date}
      />
    ));

    return (
      <div>
        <p className="title"><Translate id="recentReviews" /></p>
        {reviews.length === 0
          && <p className="reg-text"><Translate id="noReviews" /></p>}
        {recentReviews}
      </div>
    );
  }
}

RecentReviewPanel.propTypes = {
  chsiteId: PropTypes.string.isRequired,
  activeLanguage: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default withLocalize(RecentReviewPanel);
